import PropTypes from 'prop-types';
import EditTrainingDialog from './EditTrainingDialog';
import NewTrainingDialog from './NewTrainingDialog';

// ----------------------------------------------------------------------

export default function TrainingDialog(props) {

  return props.id ? <EditTrainingDialog {...props} /> : <NewTrainingDialog {...props} />;
}

TrainingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number
};
